import {
  AssetCategory,
  AssetCategoryDetail,
  AssetTag,
  CreateAssetCategoryTag,
  IqueryParams,
} from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createAssetCategory = async (data: AssetCategory) => {
  return apiService.apiRequest<AssetCategory>("post", `asset-categories`, data);
};
const updateAssetCategory = async (
  asset_category_id: string,
  data: AssetCategory
) => {
  return apiService.apiRequest<AssetCategory>(
    "put",
    `asset-categories/${asset_category_id}`,
    data
  );
};
const getAssetCategories = async (queryParams?: IqueryParams) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetCategoryDetail[]>(
    "get",
    `asset-categories${query}`
  );
};

const createAssetCategoryTag = async (data: CreateAssetCategoryTag) => {
  return apiService.apiRequest<AssetCategoryDetail>(
    "post",
    `asset-categories/tags`,
    data
  );
};

const getAssetCategory = async (category_id: string) => {
  return apiService.apiRequest<AssetCategoryDetail>(
    "get",
    `asset-categories/${category_id}`
  );
};

const deleteAssetCategory = async (category_id: string) => {
  return apiService.apiRequest<any>(
    "delete",
    `asset-categories/${category_id}`
  );
};

const deleteAssetCategoryTag = async (
  asset_category_id: string,
  asset_category_tag_id: string
) => {
  return apiService.apiRequest<any>(
    "delete",
    `asset-categories/${asset_category_id}/tags/${asset_category_tag_id}`
  );
};

const getAssetCategoryTags = async (category_id: string) => {
  return apiService.apiRequest<AssetTag[]>(
    "get",
    `asset-categories/${category_id}/tags`
  );
};
const restoreAssetCategory = async (category_id: string) => {
  return apiService.apiRequest<AssetCategory>(
    "patch",
    `asset-categories/${category_id}/restore`
  );
};

export const AssetCategoryApi = {
  createAssetCategory,
  getAssetCategories,
  getAssetCategory,
  createAssetCategoryTag,
  deleteAssetCategory,
  getAssetCategoryTags,
  restoreAssetCategory,
  deleteAssetCategoryTag,
  updateAssetCategory,
};
